(() => {
  if (customElements.get("gift-card-recipient-form")) {
    return;
  }

  class GiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checker = this.querySelector("[data-checker]");

      if (this.checker) {
        this.checker.addEventListener("click", this.cleanFields.bind(this));
      }

      this.emailField = this.querySelector('input[name="properties[Recipient email]"]');
    }

    cleanFields() {
      // Clear all recipient fields
      this.querySelector("[data-recipient-fields]")
        .querySelectorAll("*[id^=Recipient]")
        .forEach((field) => (field.value = ""));

      // Enable or disable 'required' on the email field based on checker
      if (this.emailField) {
        this.emailField.required = this.checker.checked;
      }
    }
  }

  customElements.define("gift-card-recipient-form", GiftCardRecipientForm);
})();
